import React, { useEffect, useState } from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import { useQuery } from '@apollo/client';
import { USER_STATUS_QUERY } from 'Queries/Queries';
import { useAuth } from 'context/Auth';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';
import { useMyTasks } from 'hooks/UseMyTasks';

import { EventsCardLong } from 'components/EventsCard/EventsCardLong';
import { HomepageCard } from 'components/HomepageCard/HomepageCard';
import { Image } from 'components/Image';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { Separator } from 'components/Separator/Separator';

import { EIV_STATUS_NOT_RELEVANT } from 'global/constants';

import { getLexikonUrl } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import { getSitesCards } from './HomePageComponentData';
import { SiteBlockedModal } from './SiteBlockedModal';

import './HomePageComponent.sass';

const HomePageComponent = () => {
  const { sites } = getSitesCards(getTenantId());
  const [showLexikon, setShowLexikon] = useState(true);
  const [siteBlocked, setSiteBlocked] = useState(false);
  const { isCIAM } = useAuth();
  const { installer, isLoading: isInstallerLoading } = useCurrentInstaller({ skip: !isCIAM });
  const { openTaskCount } = useMyTasks();

  const { data: userStatusData } = useQuery(USER_STATUS_QUERY, { fetchPolicy: 'network-only' });
  useEffect(() => {
    if (isCIAM && !isInstallerLoading && installer) {
      if (
        EIV_STATUS_NOT_RELEVANT.includes(installer.statusStrom) &&
        EIV_STATUS_NOT_RELEVANT.includes(installer.statusGas)
      ) {
        setSiteBlocked(true);
      }
    }
  }, [installer, isCIAM, isInstallerLoading]);

  useEffect(() => {
    const lexikonUrl = getLexikonUrl();

    fetch(lexikonUrl)
      .then((result) => {
        if (!result.ok) {
          setShowLexikon(false);
        }
      })
      .catch(() => {
        setShowLexikon(false);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);
  if (isCIAM && isInstallerLoading) {
    return <LoadingIndicator />;
  }

  return siteBlocked ? (
    <SiteBlockedModal installer={installer} />
  ) : (
    <div id="top-element" className=" home-page">
      <Separator />
      <Image />
      <div className="home-page__content">
        <div className="home-page__content-stage">
          <div className="mdl-grid home-page__content-sites">
            {sites.map((card) => {
              const key = card.id;
              if (card.showNotifications) {
                const dynCardData = { ...card };
                dynCardData.teaser.elementsList[0].number =
                  userStatusData?.userStatus?.notifications?.articles;
                dynCardData.teaser.elementsList[1].number =
                  userStatusData?.userStatus?.notifications?.events;
                return <HomepageCard key={key} data={dynCardData} />;
              }
              if (card.isLexikon) {
                return <HomepageCard key={key} data={card} disabled={!showLexikon} isLexikon />;
              }
              if (card.showTaskCount) {
                const dynCardData = {
                  ...card,
                  teaser: {
                    elementsList: card.teaser.elementsList.map((el) => ({ ...el })),
                  },
                };
                const lastIndex = dynCardData.teaser.elementsList.length - 1;
                dynCardData.teaser.elementsList[lastIndex].number = openTaskCount;
                return <HomepageCard key={key} data={dynCardData} />;
              }
              return <HomepageCard key={key} data={card} />;
            })}
          </div>
          <EventsCardLong />
        </div>
      </div>
    </div>
  );
};

MapTo('e-fix/components/content/startpage')(HomePageComponent);
